import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RegelSet } from '../../models/RegelSet';

@Component({
  selector: 'app-regel-set-dialog',
  templateUrl: './regel-set-dialog.component.html',
  styleUrls: ['./regel-dialog.component.scss']
})
export class RegelSetDialogComponent {
  action: string;
  local_data: any;

  constructor(
    public dialogRef: MatDialogRef<RegelSetDialogComponent>,
    //@Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: RegelSet
  ) {
    console.log(data);
    this.local_data = { ...data };
    this.action = this.local_data.action;
  }

  doAction() {
    this.dialogRef.close({ event: this.action, data: this.local_data });
  }

  closeDialog() {
    this.dialogRef.close({ event: 'Annuleren' });
  }
}
